import { useState } from 'react';

interface RegisterResponse {
  [key: string]: any; // ajuste conforme a resposta da sua API
}

export function useRegister() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<RegisterResponse | null>(null);

  const baseUrl = process.env.REACT_APP_BASE_API_URL


  async function register({
    firstName,
    lastName,
    email,
    password,
  }: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
  }) {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await fetch(`${baseUrl}/api/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          first_name: firstName,
          last_name: lastName,
          email,
          password,
        }),
      });

      const json = await response.json();

      if (!response.ok) {
        throw json;
      }

      setData(json);
      return json;

    } catch (err) {
      console.log("Erro recebido do servidor:", err);

      // Caso erro do backend seja do tipo { email: ["mensagem"] }
      if (err.email && Array.isArray(err.email)) {
        setError({ message: err.email[0] });
      }
      else if (err.detail) {
        setError({ message: err.detail });
      }
      else {
        setError({ message: "Unexpected error occurred." });
      }

      return null;
    }
    finally {
      setLoading(false);
    }
  }

  return { loading, error, data, register };
}
